import { Link, useLocation } from "react-router";
import {
  urlHome,
  urlRegisterPlayer,
  urlRegisterPlayerLastName,
} from "../../../urls";
import { Button } from "@repo/ui/components/button";
import { Keyboard } from "../../../components/keyboard";
import { useState } from "react";
import { useSendEvent } from "../../../hooks/use-send-event";
import { cn } from "@repo/ui/lib/utils";
import { Title } from "../../../components/title";
import { Container } from "../../../components/container";
import { InputText } from "../../../components/input-text";

function PlayerName() {
  const { state } = useLocation();
  const [name, setName] = useState(state?.name || "");
  const sendEvent = useSendEvent();

  return (
    <Container>
      <Title className="text-2xl!">¿Cuál es tu nombre?</Title>
      <InputText value={name} placeholder="Escribe tu nombre..." />
      <Keyboard onChange={setName} value={name} mode="capitalize" />
      <Button
        asChild
        variant="pos"
        size="4xl"
        className={cn(
          "w-full",
          name.length > 2 ? "" : "opacity-50 cursor-not-allowed!"
        )}
        onClick={(e) => {
          if (name.length < 3) {
            e.preventDefault();
            return;
          }
          sendEvent("enter_name", { name });
        }}
      >
        <Link
          to={urlRegisterPlayerLastName()}
          viewTransition
          state={{ ...state, name }}
        >
          Continuar
        </Link>
      </Button>
    </Container>
  );
}

export const route = {
  path: urlRegisterPlayer(),
  element: <PlayerName />,
  handle: {
    backLink: urlHome(),
  },
};
